module.exports = {
	"linkAccess": "Accès du personnel",
	"linkLogo": "Logo et image encanteur",
	"linkProfile": "Profil encanteur",
	"profile": {
		"header": "Paramètres du profil de l'organisation"
	},
	"menu": {
		"backToMain": "Retour au site principal",
		"backToDashboard": "Retour au tableau de bord"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/oa-settings.json5
// module id = 1998
// module chunks = 6